import { render, staticRenderFns } from "./VirtualMachineEdit.vue?vue&type=template&id=e48cd0f6&scoped=true&"
import script from "./VirtualMachineEdit.vue?vue&type=script&lang=js&"
export * from "./VirtualMachineEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48cd0f6",
  null
  
)

export default component.exports